export default __webpack_public_path__ + "static/media/sap.2ee0d717.jpg";